module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'alert alert-dismissible ' + _vm.classType,
    attrs: {
      "role": "alert"
    }
  }, [(!_vm.notice['ignorable']) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.notice['ignorable']) ? _c('b-dropdown', {
    staticClass: "pull-right",
    attrs: {
      "id": "ignore-btn",
      "text": "",
      "type": "default",
      "disabled": false
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.ignoreNotice()
      }
    }
  }, [_vm._v("Ignore")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Acknowledge")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.notice['content']))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7c81e9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notice.vue
// module id = 1344
// module chunks = 16